import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * The confirmation, attached to the table instead of floating beside it.
 *
 * Accounting's report was "the flash message does not show in the table": the
 * toast names a document number in the corner of the screen while the list
 * gives no way to tell which of forty rows it means. This says it where she is
 * looking, and the row itself carries `row-just-saved`.
 *
 * Renders nothing when there is no saved row, including when the saved row
 * fell outside the fetched page -- in that case the toast stands alone rather
 * than pointing at a row that is not there.
 */
const SavedRowBanner = ({ savedId, label }) => {
  if (savedId === null || savedId === undefined) return null;

  return (
    <div className="invoice-list-saved-banner" role="status">
      <FontAwesomeIcon icon={faCheckCircle} />
      <span>
        {label
          ? `Saved — ${label} is highlighted below.`
          : 'Saved — your row is highlighted below.'}
      </span>
    </div>
  );
};

export default SavedRowBanner;
